import React from "react";
import { TableHeaderColumn } from "react-bootstrap-table";
import { moveFormatter } from "../../fomatters/BooleanFormatter";
import Crud from "../Crud";

/**
 * TABLE SYSTEMCOLORS
 */
function PlayerSource() {
  return (
    <Crud
      title="Source"
      getUrl={() => "/Player/Source_GetList"}
      // INSERT
      insertUrl={() => "/Player/Source_Insert"}
      insertParams={({ userId }, { sourceName }) => ({
        SourceName: sourceName,
        IdUser: Number(userId),
      })}
      // UPDATE
      updateUrl={() => "/Player/Source_Update"}
      updateParams={({ userId }, { idSource, sourceName }) => ({
        IdSource: idSource,
        SourceName: sourceName,
        IdUser: Number(userId),
      })}
      // DELETE
      deleteUrl={() => "/Player/Source_Delete"}
      deleteParams={({ userId }, id) => ({
        IdSource: id,
        IdUser: Number(userId),
      })}
    >
      <TableHeaderColumn
        visible="none"
        hiddenOnInsert
        autoValue={true}
        hidden
        isKey
        dataField="idSource"
      >
        Id
      </TableHeaderColumn>
      <TableHeaderColumn
        dataField="sourceName"
        filter={{ type: "TextFilter", delay: 1000 }}
      >
        Name
      </TableHeaderColumn>
    </Crud>
  );
}

export default PlayerSource;
